import { Footer, FooterLite, Header } from '@aspendental/shared-components-web';
import { Box } from '@mui/material';
import Head from 'next/head';
import { ReactNode, useEffect, useState } from 'react';
import { AdFooter, App, Maybe } from '@src/lib/__generated/sdk';
import { useAppStore } from '@src/store';
interface LayoutPropsInterface {
  children: ReactNode;
  appData: Maybe<App>;
  footerData: Maybe<AdFooter>;
  isFooterLite?: boolean;
  withSimpleLayout?: boolean;
  locale: string;
  preview: boolean;
  logoHref: string;
  hideLocation?: boolean;
  hidePrimaryActionButton?: boolean;
}
export const Layout = ({
  appData,
  footerData,
  isFooterLite = true,
  withSimpleLayout = false,
  children,
  logoHref,
  hideLocation = false,
  hidePrimaryActionButton = false
}: LayoutPropsInterface) => {
  const [isClient, setIsClient] = useState(false);
  const setFeatureFlags = useAppStore(state => state.setFeatureFlags);
  useEffect(() => {
    setIsClient(true);
    setFeatureFlags(appData?.featureFlags);
  }, []);
  useEffect(() => {
    const scopedBaseline = document.getElementById('mui-scoped-baseline');
    if (scopedBaseline?.style) {
      scopedBaseline.style.overflowX = 'unset';
    }
  }, []);
  if (!isClient) {
    return null;
  }
  const withFixedHeader = true;
  const showHeaderNavMenu = true;
  return <Box sx={{
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column'
  }} data-sentry-element="Box" data-sentry-component="Layout" data-sentry-source-file="layout.tsx">
			<Head data-sentry-element="Head" data-sentry-source-file="layout.tsx">
				<title>Book an appointment | Med Spa Treatments | Chapter Aesthetic Studio</title>
			</Head>
			{appData && <Header appData={appData as any} withMenuCTA={false} hideLocation={hideLocation} hidePrimaryActionButton={hidePrimaryActionButton} logoHref={logoHref} phoneNumber={appData?.header?.phoneNumber} showHeaderNavMenu={showHeaderNavMenu} withFixedHeader={withFixedHeader} useHeaderLocationCards={appData?.header?.useHeaderLocationCards} />}
			{children}
			<Box sx={{
      mt: 'auto'
    }} data-sentry-element="Box" data-sentry-source-file="layout.tsx" />
			{footerData && isFooterLite ? <FooterLite footerData={footerData} /> : <Footer footerData={footerData} withScheduling={withSimpleLayout} isLightFooter={!!footerData?.isLightFooter} />}
		</Box>;
};